'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import AppLink from '@/components/elementary/AppLink';
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import { PRICING_CTA_SECTIONS } from '@/constants/pricing.constants';
import { createTrackingContext } from '@/lib/analytics/analytics';
import { cn } from '@/lib/styles';
import styles from '../featureComparison/FeatureCell.module.css';
export function BillingDetails(t0) {
  const $ = _c(15);
  const {
    title,
    button,
    price,
    priceUnderline
  } = t0;
  const t = useTranslations("Pricing");
  let t1;
  if ($[0] !== price || $[1] !== t) {
    t1 = price ? <div className="lok-text-display-large mb-2 text-neutral-light-100">{t("dollar")}{price}<span className="lok-text-display-large">{t("mo")}</span></div> : null;
    $[0] = price;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== priceUnderline) {
    t2 = priceUnderline ? <div className="mb-5 lg:mb-7"><CkEditorCSRRenderer htmlContent={priceUnderline} className={cn(styles["table-cell-content"], "xl:whitespace-nowrap text-neutral-light-100")} defaultTypography="bodyMedium" /></div> : null;
    $[3] = priceUnderline;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== button?.icon || $[6] !== button?.link?.href || $[7] !== button?.link?.label || $[8] !== button?.link?.newTab || $[9] !== title) {
    t3 = button?.link?.href ? <AppLink variant="primary" inverted={true} size="large" href={button?.link?.href} openExternalInNewTab={button?.link?.newTab ?? false} className="w-full shrink-0" trackingContext={createTrackingContext({
      plan: title ?? undefined,
      planSection: PRICING_CTA_SECTIONS.FEATURED
    })}>{button?.icon ? <div className="relative size-6 shrink-0"><BasicImage fill={true} loading="lazy" component={button?.icon} className="object-contain" /></div> : null}{button?.link?.label}</AppLink> : null;
    $[5] = button?.icon;
    $[6] = button?.link?.href;
    $[7] = button?.link?.label;
    $[8] = button?.link?.newTab;
    $[9] = title;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = <div className="pt-6 lg:pt-0">{t1}{t2}{t3}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}